import type { KnowledgeArticle } from "../types"

export const aiAutomatiseringMkb: KnowledgeArticle = {
  id: "insight:ai-automatisering-mkb",
  pageType: "knowledge-article",
  slug: { nl: "ai-automatisering-mkb" },
  title: {
    nl: "AI Automatisering voor het MKB | Waar begin je?",
    en: "AI Automatisering voor het MKB | Waar begin je?",
  },
  description: {
    nl: "AI automatisering voor het MKB: welke taken zich lenen, hoe je het eerste proces kiest, wat je meet en welke valkuilen je voorkomt. Praktisch, zonder hype.",
    en: "AI automatisering voor het MKB: welke taken zich lenen, hoe je het eerste proces kiest, wat je meet en welke valkuilen je voorkomt. Praktisch, zonder hype.",
  },
  h1: {
    nl: "AI automatisering voor het MKB: waar begin je?",
    en: "AI automatisering voor het MKB: waar begin je?",
  },
  published: "2026-10-29",
  modified: "2026-10-29",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "Voor een mkb-bedrijf is AI automatisering interessant omdat het werk aanpakt dat tot nu toe te rommelig was voor klassieke automatisering: berichten lezen, documenten beoordelen, gegevens uit vrije tekst halen. Je hebt er geen groot data-team voor nodig, wel een goed gekozen eerste proces.",
    },
    {
      type: "heading",
      text: "Wat is AI automatisering?",
    },
    {
      type: "paragraph",
      text: "Klassieke automatisering volgt vaste regels: als dit, dan dat. AI automatisering voegt daar begrip van taal en inhoud aan toe. Het systeem kan een e-mail lezen, bepalen waar die over gaat, de relevante gegevens eruit halen en een volgende stap klaarzetten. Het werk blijft een proces met duidelijke stappen; AI neemt alleen de onderdelen over waar interpretatie nodig is.",
    },
    {
      type: "heading",
      text: "Welke taken lenen zich ervoor?",
    },
    {
      type: "list",
      items: [
        "Categoriseren en classificeren: inkomende berichten, aanvragen of tickets automatisch in de juiste bak leggen.",
        "Gegevens uitlezen: informatie uit offertes, facturen of formulieren omzetten naar gestructureerde data.",
        "Concepten opstellen: een antwoord of rapportage voorbereiden die een medewerker controleert en verstuurt.",
        "Zoeken en samenvatten: de juiste informatie uit documenten en systemen bij elkaar brengen.",
        "Publicatie- en contentworkflows: herhaalwerk rond tekst, zoals bij De Limburger, waar AI een publicatieproces ondersteunt.",
      ],
    },
    {
      type: "heading",
      text: "Hoe kies je het eerste proces?",
    },
    {
      type: "paragraph",
      text: "Zoek een proces dat vaak terugkomt, merkbaar tijd kost en waarvan de uitkomst duidelijk te beoordelen is. Een goed eerste proces heeft een eigenaar die het kent, bruikbare voorbeelden uit het verleden en een begrensd risico bij een fout. Vermijd het grootste of meest gevoelige proces als startpunt: eerst vertrouwen opbouwen, dan uitbreiden.",
    },
    {
      type: "heading",
      text: "Meet vóór je bouwt",
    },
    {
      type: "paragraph",
      text: "Leg vooraf vast hoeveel tijd het proces nu kost, hoe vaak er fouten gemaakt worden en wat een goede uitkomst is. Zonder die baseline kun je achteraf niet aantonen wat de automatisering oplevert, en kun je niet bijsturen als de kwaliteit tegenvalt.",
    },
    {
      type: "heading",
      text: "Houd een mens in de lus",
    },
    {
      type: "paragraph",
      text: "Begin met AI die voorbereidt en een medewerker die goedkeurt. Zie je dat de kwaliteit op een bepaalde taak consistent hoog is, dan kun je daar stap voor stap meer overlaten aan het systeem. Goedkeurstappen zijn geen zwakte maar een ontwerpkeuze.",
    },
    {
      type: "heading",
      text: "Veelgemaakte valkuilen",
    },
    {
      type: "list",
      items: [
        "Beginnen met de technologie in plaats van met het proces dat pijn doet.",
        "Te veel tegelijk willen automatiseren, waardoor niets echt af komt.",
        "Het proces niet eerst opschonen: een rommelig proces automatiseren geeft een snel rommelig proces.",
        "Geen eigenaar aanwijzen voor beheer na livegang.",
        "AI inzetten waar een vaste regel volstaat. Lees daarvoor ook wanneer een bedrijf juist géén AI moet gebruiken.",
      ],
    },
    {
      type: "callout",
      title: "Niet zeker waar je moet beginnen?",
      text: "Een AI-quickscan van je processen laat zien waar automatisering het meeste oplevert, en waar niet. We adviseren bedrijven regelmatig om een idee níet te bouwen; dat scheelt geld en teleurstelling.",
    },
  ],
  relatedServiceIds: ["ai-automation", "ai-consultancy"],
  relatedCaseIds: ["de-limburger"],
}
